import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ItemData } from './item.api'
import { LocationTypeData } from './locationType.api'
import { PalletData } from './pallet.api'
import { UserData } from './user.api'

export interface LocationData {
  id: number
  siteId: number
  typeId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  name: string
  capacity: number
  type?: LocationTypeData
  deletedAt?: string
  createdAt: string
  updatedAt: string
  isDeleted: boolean
  createdUser?: UserData
  updatedUser?: UserData
}

export interface LocationListBinItemsRequest {
  id?: number
  bin?: string
}

export interface LocationExportBinItemsRequest {
  id?: number
  bin?: string
}

export interface LocationListBinItemPalletsRequest {
  id: number
  bin: string
  itemId: number
}

export type LocationExportBinItemPalletsRequest = LocationListBinItemPalletsRequest

export interface LocationCreateRequest {
  location?: string
  locationType?: number
  capacity?: number
}

export interface LocationUpdateRequest {
  location?: string
  capacity?: number
}

const routes = {
  list: '/locations',
  listBinItems: '/locations/bins/items',
  exportBinItems: '/locations/bins/items/export',
  listBinItemPallets: '/locations/{id}/bins/{bin}/items/{itemId}/pallets',
  exportBinItemPallets: '/locations/{id}/bins/{bin}/items/{itemId}/pallets/export',
  delete: '/locations/{id}',
  create: '/locations',
  read: '/locations/{id}',
  update: '/locations/{id}'
}

export default {
  list (callback: ResponseCallback<LocationData[]>) {
    api.get(routes.list, {}, callback)
  },

  listBinItems (
    payload: LocationListBinItemsRequest,
    callback: ResponseCallback<ItemData[]>
  ) {
    api.get(routes.listBinItems, payload, callback)
  },

  exportBinItems (
    payload: LocationExportBinItemsRequest,
    callback: ResponseCallback<Blob>
  ) {
    api.get(routes.exportBinItems, payload, callback)
  },

  listBinItemPallets (
    params: LocationListBinItemPalletsRequest,
    callback: ResponseCallback<PalletData[]>) {
    const url = routeUtil.replaceParams(routes.listBinItemPallets, params)
    api.get(url, {}, callback)
  },

  exportBinItemPallets (
    params: LocationExportBinItemPalletsRequest,
    callback: ResponseCallback<Blob>
  ) {
    const url = routeUtil.replaceParams(routes.exportBinItemPallets, params)
    api.get(url, {}, callback)
  },

  delete (id: number, callback: ResponseCallback<LocationData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (
    payload: LocationCreateRequest,
    callback: ResponseCallback<LocationData>
  ) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<LocationData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: LocationUpdateRequest,
    callback: ResponseCallback<LocationData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  }
}
